import { businessInfo, packages, faqs } from '../data/mock';

export const JsonLd = () => {
  const localBusiness = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': 'https://www.soundhiretarneit.au/#business',
    name: 'Sound Hire Tarneit',
    alternateName: 'Sound Hire Tarneit Melbourne',
    description: businessInfo.description,
    url: 'https://www.soundhiretarneit.au',
    logo: 'https://www.soundhiretarneit.au/logo.png',
    image: 'https://www.soundhiretarneit.au/og-image.png',
    telephone: '+61491617474',
    email: businessInfo.contact.email,
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Tarneit',
      addressRegion: 'VIC',
      addressCountry: 'AU',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: -37.8297,
      longitude: 144.6936,
    },
    areaServed: [
      { '@type': 'City', name: 'Melbourne' },
      { '@type': 'City', name: 'Tarneit' },
      { '@type': 'City', name: 'Werribee' },
      { '@type': 'City', name: 'Point Cook' },
      { '@type': 'City', name: 'Truganina' },
      { '@type': 'City', name: 'Wyndham Vale' },
      { '@type': 'City', name: 'Hoppers Crossing' },
    ],
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: [
        'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday',
      ],
      opens: '08:00',
      closes: '22:00',
    },
    priceRange: '$100–$200',
    sameAs: [
      businessInfo.contact.facebook,
      `https://wa.me/${businessInfo.contact.whatsapp}`,
    ],
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Sound Hire Packages',
      itemListElement: packages.map((pkg) => ({
        '@type': 'Offer',
        name: pkg.name,
        description: pkg.items.join(', '),
        price: pkg.price,
        priceCurrency: 'AUD',
        availability: 'https://schema.org/InStock',
        url: 'https://www.soundhiretarneit.au/#packages',
      })),
    },
  };

  const faqPage = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'Sound Equipment Hire',
    provider: {
      '@type': 'LocalBusiness',
      name: 'Sound Hire Tarneit',
    },
    areaServed: {
      '@type': 'City',
      name: 'Melbourne',
    },
    description:
      'Professional PA system hire, speaker hire, and party lighting hire for weddings, birthdays, corporate events, and parties across Melbourne.',
    offers: {
      '@type': 'AggregateOffer',
      lowPrice: '100',
      highPrice: '200',
      priceCurrency: 'AUD',
      offerCount: packages.length,
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusiness) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqPage) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceSchema) }}
      />
    </>
  );
};
